export type Environment = "local" | "test" | "accept" | "prod";
